<template>
  <div
    v-if="variant === 'primary'"
    :id="id"
    class="topics-wrapper-primary"
  >
    <div class="topics-wrapper-primary__container">
      <c-title
        v-if="variant === 'primary'"
        size="h2"
      >
        <slot name="title" />
      </c-title>
      <c-text
        size="xs"
        weight="400"
      >
        <slot name="text" />
      </c-text>
      <div class="topics-wrapper-primary__topics">
        <slot name="topics" />
      </div>
    </div>
    <div class="topics-wrapper-primary__image">
      <c-image
        :alt="alt"
        :image-mobile="imageMobile"
        :image-tablet="imageTablet"
        :image-desktop="imageDesktop"
        :max-image-size="maxImageSize"
      />
    </div>
  </div>

  <div
    v-if="variant === 'secondary'"
    :id="id"
    class="topics-wrapper-secondary"
  >
    <div class="topics-wrapper-secondary__container">
      <div class="topics-wrapper-secondary__image">
        <c-image
          :alt="alt"
          :image-mobile="imageMobile"
          :image-tablet="imageTablet"
          :image-desktop="imageDesktop"
          :max-image-size="maxImageSize"
        />
      </div>
      <div class="topics-wrapper-secondary__topics">
        <c-text
          color="#001032"
          class="topics-wrapper-secondary__text"
        >
          <slot name="text" />
        </c-text>
        <slot name="topics" />
      </div>
    </div>
  </div>

  <div
    v-if="variant === 'tertiary'"
    :id="id"
    class="topics-wrapper-tertiary"
  >
    <div class="topics-wrapper-tertiary__topics">
      <c-text
        color="#001032"
        class="topics-wrapper-tertiary__text"
      >
        <slot name="text" />
      </c-text>
      <slot name="topics" />
    </div>
    <div class="topics-wrapper-tertiary__image">
      <c-image
        :alt="alt"
        :image-mobile="imageMobile"
        :image-tablet="imageTablet"
        :image-desktop="imageDesktop"
        :max-image-size="maxImageSize"
      />
    </div>
  </div>
</template>

<script>
import CTitle from '@atoms/title/title.vue'
import CText from '@atoms/text/text.vue'
import CImage from '@atoms/image/image.vue'

export default {
  name: 'topics-wrapper',
  components: { CTitle, CText, CImage },
  props: {
    variant: {
      type: String,
    },
    alt: {
      type: String,
    },
    imageMobile: {
      type: String,
    },
    imageTablet: {
      type: String,
    },
    imageDesktop: {
      type: String,
    },
    maxImageSize: {
      type: String,
      default: null,
    },
    id: {
      type: String,
    },
  },
}
</script>

<style lang="scss" scoped>
.topics-wrapper-primary {
  background-color: $blue-06;
  padding: 4rem 2.25rem 3.375rem 2rem;

  @media screen and (min-width: 1200px) {
    padding: 4.875rem 6.5rem 4.438rem 6.813rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    justify-items: center;
    column-gap: 2.5rem;
  }

  &__container {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  &__topics {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 1rem;
    row-gap: 2.5rem;
    margin-top: 0.688rem;
    margin-bottom: 3.375rem;

    @media screen and (min-width: 768px) {
      grid-template-columns: repeat(3, 1fr);
      gap: 2.5rem;
      margin-top: 2rem;
    }
  }
}

.topics-wrapper-secondary {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: $white;

  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;

    @media screen and (min-width: 1200px) {
      display: grid;
      grid-template-columns: repeat(2, auto);
      column-gap: 9.688rem;
    }
  }

  &__image {
    max-width: 20rem;
    max-height: 20rem;
    border-radius: 50%;
    overflow: hidden;
    margin-top: 3.813rem;
    margin-bottom: 4.875rem;

    @media screen and (min-width: 1200px) {
      max-width: 32.375rem;
      max-height: 32.375rem;
      margin: unset;
    }
  }

  &__topics {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    justify-items: stretch;
    column-gap: 1.25rem;
    row-gap: 2rem;

    div {
      display: block
    }

    @media screen and (min-width: 1200px) {
      column-gap: 2rem;
      row-gap: 2.5rem;
    }
  }

  &__text {
    @include font-telegraf(400);
    font-size: 1.5rem;
    line-height: 130%;
    max-width: min-content;

    @media screen and (min-width: 1200px) {
      font-size: 2rem;
    }
  }
}

.topics-wrapper-tertiary {
  @extend .topics-wrapper-secondary__container;
  flex-direction: column-reverse;

  @media screen and (min-width: 1200px) {
    justify-items: center;
    justify-content: center;
    align-items: center;
  }

  &__topics {
    @extend .topics-wrapper-secondary__topics;
  }

  &__text {
    @extend .topics-wrapper-secondary__text;
    grid-area: 1 / 2 / 2 / 3;
  }

  &__image {
    @extend .topics-wrapper-secondary__image;
  }
}
</style>
